export { default } from './CheckTypeQuiz';



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/CheckTaskInputs/CheckTypeQuiz/index.js